import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { loader } from "~/misc/common";

export default class extends Controller {
	connect() {
		console.log('initSpecDaysTable');

		$('.datetimepicker').datetimepicker().on('dp.change', function (ev) {
			$('#applyFilters').show(300);
		});

		$('.q_month_eq label').prepend('<div class="btn-group"><a class="btn btn-default btn-xs" id="prevDay"><i class="fa fa-chevron-left"></i></a><a class="btn btn-default btn-xs" id="nextDay"><i class="fa fa-chevron-right"></i></a></span> ');

		$('#prevDay').on('click', function () {
			const date = $('#q_month_eq').parent().datetimepicker().data("DateTimePicker").date();
			if (date) {
				$('#q_month_eq').parent().datetimepicker().data("DateTimePicker").date(date.subtract(1, 'months'));
			}
		});

		$('#nextDay').on('click', function () {
			const date = $('#q_month_eq').parent().datetimepicker().data("DateTimePicker").date();
			if (date) {
				$('#q_month_eq').parent().datetimepicker().data("DateTimePicker").date(date.add(1, 'months'));
			}
		});

		$('.cr-copy').on('click', function () {
			const btn = $(this);
			loader(true);
			$.get('/spec_days/copy/' + $(this).data('user') + '.json?month=' + $(this).data('month'), function (data) {
				console.log(data);
				navigator.clipboard.writeText(JSON.stringify(data));
				loader(false);
				btn.blur();
				btn.removeClass('btn-default');
				btn.addClass('btn-success');
			});
		});

	}
}
